import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

const CAPTURE_CONSTRAINTS = {
  audio: false,
  video: {
    width: { ideal: 1280 },
    height: { ideal: 1024 },
    facingMode: 'environment'
  }
};

@Component({
  selector: 'app-capture-page',
  templateUrl: './capture-page.component.html',
  styleUrls: ['./capture-page.component.scss']
})
export class CapturePageComponent {
  constructor() {}
}
